module.exports = __webpack_public_path__ + "img/cpyj-2-sm.ace75f9b.jpg";